import { TAB_CATEGORY } from '@/constant/permission'
import { createI18nProperty } from '@/i18n'
import BlankLayout from '../../layout/blankLayout.vue'
import resumeEditor from './editor.vue'

const routes = [
  {
    name: 'newCandidateEditor',
    path: '/v-admin/application/job/:jobId/edit/:applicationId',
    component: resumeEditor,
    meta: {
      isEditMode: true,
      titleI18nKey: 'admin.application.candidate.title.editCandidate',
      personalLayout: {
        blankPage: true
      },
      rootLayout: {
        hiddenLeftPadding: true
      }
    }
  },
  {
    name: 'newAddCandidateResume',
    path: '/v-admin/application/job/:jobId/add',
    component: resumeEditor,
    meta: {
      isEditMode: false,
      titleI18nKey: 'admin.application.candidate.title.addCandidate',
      personalLayout: {
        blankPage: true
      },
      rootLayout: {
        hiddenLeftPadding: true
      }
    }
  }
]
const applicationRoute = {
  path: '/candidates/:jobId/',
  component: BlankLayout,
  meta: {
    permission: TAB_CATEGORY.JOB,
    titleI18nKey: 'admin.candidate.title',
    tab: createI18nProperty({
      customClass: ['candidate'],
      customShowFunc: (hasPermission, currentRoute) => {
        if (!hasPermission) {
          return false
        }
        if (currentRoute.path === `/candidates/${currentRoute.params.candidateId}/`) {
          return true
        } else {
          let parent = currentRoute
          while ((parent = parent.meta._parent)) {
            if (parent === applicationRoute) {
              return true
            }
          }
          return false
        }
      }
    }, 'label', 'admin.candidate.tab')
  },
  children: routes
}
export default applicationRoute
